// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xUqvq","content":"styles_content__tGVJo","title":"styles_title__t3mdV","actions":"styles_actions__btftP"};